<template>
    <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-flex-col tw-w-full">
            <div class="h7 tw-hidden lg:tw-flex tw-w-full pb-2 tw-border-b tw-border-dark-grey">
                <solid-black-arrows @click="goToEvents" :flip="true" /> <a class="mt-2 ml-2" :href="route('news-and-events.index')">All NEWS & EVENTS</a>
            </div>
            <div class="tw-mt-5 tw-pb-5">
                <HomeNewsArticle
                    :flex-row="true"
                    :image="event.image"
                    :title="event.title"
                    :date="$root.smartDate(event.date)"
                    :content="event.content"
                    link="#"
                />
            </div>
        </div>

        <div class="splideContainer">
            <Splide
                class="tw-pb-14"
                ref="splide1"
                :options="splide_options"
            >
                <SplideSlide
                    v-for="(slide, index) in events"
                    :key="index"
                >
                    <div class="tw-flex tw-flex-row tw-divide-x tw-divide-dark-grey tw-border-t tw-border-dark-grey tw-gap-2">
                        <div class="tw-flex tw-flex-col tw-w-1/2 tw-px-2"
                             v-for="(ev, index2) in slide"
                             :key="index2"
                        >
                            <div class="tw-mt-5 tw-pb-5"
                            >
                                <div class="h7 tw-hidden lg:tw-flex tw-w-full tw-pb-6" :class="index2 !== 0 ? 'tw-justify-end' : ''">
                                    <a @click="index2 === 0 ? goPrev() : goNext()">
                                        <!-- You may need to modify this part according to your needs -->
                                        {{ index2 === 0 ? 'PREVIOUS' : 'NEXT' }}
                                    </a>
                                </div>
                                <HomeNewsArticle
                                    v-if="ev"
                                    :flex-row="true"
                                    :flex-reverse="index2 !== 0"
                                    :image="ev.image"
                                    :title="ev.title"
                                    :date="$root.smartDate(ev.date)"
                                    :content="''"
                                    :link="route('news-and-events.show', ev.id)"
                                />
                            </div>
                        </div>
                    </div>
                </SplideSlide>
            </Splide>
        </div>

    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import HomeNewsArticle from "@/Pages/ExternalPages/components/HomeNewsArticle";
import SolidBlackArrows from "@/Generic/icons/SolidBlackArrows.vue";
import {Splide, SplideSlide} from "@splidejs/vue-splide";

export default {
    name: "NewsEventsShow",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    props: {
        'event': {
            type: Object,
            required: true,
            default: function () {
                return {}
            }
        },
        'events': {
            type: Array,
            required: true,
            default: function () {
                return []
            }
        },
    },
    components: {
        SolidBlackArrows,
        HomeNewsArticle,
        Splide,
        SplideSlide,
    },
    data() {
        return {
            isFlexRow: false,
            // other data properties
        };
    },
    mounted() {
        //
    },
    computed: {
        splide_options () {
            return {
                type: 'loop',
                gap: '1em',
                autoplay: false,
                pauseOnHover: true,
                resetProgress: true,
                perPage: 1,
                navigation: false,
                pagination: false,
                arrows: false
            }
        },
    },
    methods: {
        goToEvents() {
            // Inertia navigate to news-and-events.index
            this.$inertia.get(route('news-and-events.index'));
        },
        goPrev() {
            this.$refs.splide1.go('-1')

        },
        goNext() {
            this.$refs.splide1.go('+1')
        },
    },
    created() {
        import('@splidejs/splide/dist/css/splide.min.css')
    },
}
</script>
<style scoped>
ol li::marker {
    font-weight: 400;
}
li {
    font-weight: 300;
}
</style>
